/**
 * @deprecated use useDocumentTitle instead
 */
export default function DocumentTitle(title: string): void {
  if (!title.includes('undefined')) {
    document.title = title;
  } else {
    document.title = 'Import.io';
  }
}
